import api from '@/core/apiclient'
import {actionTypes, mutationTypes} from '@/core/constants'

export default {

    async [actionTypes.PARAMETROS.INSERIR_CONFIGURACAO](context, dados) {
        const {data} = await api.configuracao.inserirConfiguracao(dados)
        return data
    },

    async [actionTypes.PARAMETROS.ATUALIZAR_CONFIGURACAO](context, dados) {
        const {data} = await api.configuracao.atualizarConfiguracao(dados)
        return data
    },

    async [actionTypes.PARAMETROS.DELETAR_CONFIGURACAO](context, configuracaoId) {
        await api.configuracao.deletarConfiguracao(configuracaoId)
    },

    async [actionTypes.PARAMETROS.BUSCAR_PARAMETROS_CONFIGURACAO]({commit}) {
        const {data} = await api.configuracao.buscarParametrosConfiguracao()
        if (data) {
            commit(mutationTypes.PARAMETROS.SET_PARAMETROS, data)
        }
    },

    async [actionTypes.PARAMETROS.BUSCAR_CONFIGURACOES_SISTEMA]() {
        const {data} = await api.configuracao.buscarListaDeConfiguracoes()
        return data
    },

}